export function noticeCloseButtons() {
    const possibleNotices = document.querySelectorAll(".woocommerce-notices-wrapper");

    possibleNotices.forEach((wrapper) => {
        // if any wrapper has notices
        if (wrapper.childElementCount > 0) {
            let hasButtons = false;
            wrapper.querySelectorAll(".notice-close-button").forEach((button) => {
                hasButtons = true;
                button.addEventListener("click", () => {
                    wrapper.classList.add("hidden");
                });
            });

            // fallback in case of not buttons
            if (!hasButtons) {
                wrapper.children.forEach((button) => {
                    button.addEventListener("click", () => {
                        wrapper.classList.add("hidden");
                    });
                });
            }
        }

        // show only one notice
        if (wrapper.childElementCount > 1) {
            [...wrapper.children].slice(0, 1).forEach((extraElement) => {
                extraElement.classList.add("hidden-force");
            });
        }
    });
}
